import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AlignCenter = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24">
    <path d="M5.5 16H19.2455V14.5H5.5V16ZM8.04545 10.75V12.25H17.2091V10.75H8.04545ZM5.75455 7V8.5H19.5V7H5.75455Z" />
  </SvgIcon>
));

export default React.memo(AlignCenter);
